import { RDFData } from '../../../../../helpers/sparqlResultHelpers'
import { item_id, node_id } from '../common'

export const NO_PARENT = Symbol('NO_PARENT')
export type no_parent = typeof NO_PARENT

export type TreeData = {
  rootNodeIds: node_id[]
  nodesById: Record<node_id, TreeNode>
  itemsById: Record<item_id, TreeItem>
}

export type TreeNode = {
  id: node_id
  itemId: item_id
  childrenIds: node_id[]
  parentId: node_id | no_parent
}

export type TreeItem = {
  id: item_id
  defaultChecked: boolean
  defaultToggles: Record<string, boolean>
  uri: string
  label: TreeItemLabel
  icon: TreeItemIcon
  rightLabel: TreeItemLabel
  rightIcon: TreeItemIcon
  tooltip?: string
  canDropInto?: boolean
  rowResults: Record<string, RDFData>
}

export type TreeItemIcon = {
  name?: string
  color?: string
  size?: string
}

export type TreeItemLabel = {
  text?: string
  color?: string
}

export const EMPTY_TREE_DATA: TreeData = {
  rootNodeIds: [],
  nodesById: {},
  itemsById: {}
} as const
